






















import { Component, Vue, Prop,Inject } from 'vue-property-decorator'
import { searchToWhereUrl } from '@core/utils/jump'
@Component({
  filters: {
    getTagImg(val: string) {
      return require(`@assets/images/search/icon_matron${val}.png`)
    }
  }
})
export default class MatronItem extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any
  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_200004')
  clickid_200004!: string

  get goDetail() {
    return searchToWhereUrl({ toYuesao: true, uid: this.value.uid })
  }
  get goDetailExposure() {
    return `${this.clickid_200004}||${JSON.stringify({ name:this.value.workerName,spuid: this.value.uid })}`
  }
  goDetailClick() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200004, positionParam: { name:this.value.workerName,spuid: this.value.uid } })
  }
}
